export const    Progress  = ({percentage,height="0.15rem", round=false}) => {
    console.log(percentage)
    return(
        <div className="progression-content">
            <div className="horizontal space-between"><p className="small-text">Progressie</p><p className="small-text bold-text primary-800">{percentage}%</p></div>
            <div className="progression-bar" style={{width:`${percentage}%`,height:height, borderRadius:round&&"100px"}}></div>
        </div>
    )
}